import store from "./store";

export default {
  name: "auth",
  store: store,
};
